// API configuration
export const API_BASE = `${process.env.REACT_APP_API_URL}/api`;
export const WHATSAPP_URL = process.env.REACT_APP_WHATSAPP_URL;

// WebSocket configuration
export const WS_HOST = process.env.REACT_APP_WS_HOST;

// Google Maps configuration
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

// Add other configuration variables as needed
export default {
  API_BASE,
  WHATSAPP_URL,
  WS_HOST,
  GOOGLE_MAPS_API_KEY,
};
